import { Routes, Route } from 'react-router-dom';
import { SiteGate } from '@/providers/SiteGate';
import { PublicLayout } from '@/layouts/PublicLayout';
import { Home } from '@/pages/Home';
import { Services } from '@/pages/Services';
import { About } from '@/pages/About';
import { Pricing } from '@/pages/Pricing';
import { Contact } from '@/pages/Contact';
import { PortalLayout } from '@/pages/portal/PortalLayout';
import { PortalLogin } from '@/pages/portal/PortalLogin';
import { Dashboard } from '@/pages/portal/Dashboard';
import { ContentEditor } from '@/pages/portal/ContentEditor';
import { MediaLibrary } from '@/pages/portal/MediaLibrary';
import { Submissions } from '@/pages/portal/Submissions';
import { Settings } from '@/pages/portal/Settings';
import { RequireRole } from '@/components/portal/RequireRole';

export function App() {
  return (
    <Routes>
      <Route
        element={
          <SiteGate>
            <PublicLayout />
          </SiteGate>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal" element={<PortalLayout />}>
        {/* All portal features are admin-only for now; client features will
            be added with role="client" as they are released. */}
        <Route index element={<Dashboard />} />
        <Route
          path="content"
          element={
            <RequireRole role="admin">
              <ContentEditor />
            </RequireRole>
          }
        />
        <Route
          path="media"
          element={
            <RequireRole role="admin">
              <MediaLibrary />
            </RequireRole>
          }
        />
        <Route
          path="inquiries"
          element={
            <RequireRole role="admin">
              <Submissions />
            </RequireRole>
          }
        />
        <Route
          path="settings"
          element={
            <RequireRole role="admin">
              <Settings />
            </RequireRole>
          }
        />
      </Route>
    </Routes>
  );
}
